import { render, staticRenderFns } from "./AsignacionManual.vue?vue&type=template&id=67a41700"
import script from "./AsignacionManual.vue?vue&type=script&lang=js"
export * from "./AsignacionManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports